module.exports = __webpack_public_path__ + "img/main-2.8ef988b4.png";